import NFA from './components/custom_exports';

export default NFA;